import { initSegmentManager } from '@/segment/integration/segment';
import { logToConsole } from '@/utils/logging';

void (async (): Promise<void> => {
  try {
    await initSegmentManager();
  } catch (error: unknown) {
    logToConsole('Segment initialization failed:', error);
  }
})();
